import { Logger } from './Logger';

export function createConsoleLogger(): Logger {
  return {
    log(...message: unknown[]): void {
      console.log(...message);
    },
    info(...message: unknown[]): void {
      console.info(...message);
    },
    warn(...message: unknown[]): void {
      console.warn(...message);
    },
    error(...message: unknown[]): void {
      console.error(...message);
    },
  };
}
